

var eventsCalendar = document.querySelector('.tribe-events-header__top-bar');
if ( eventsCalendar ) {
    eventsCalendar.insertAdjacentHTML( 'beforebegin', '<a href="https://www.albion.edu/offices/camps-and-conferences/reserve-a-room/" class="add-event">+ <span>Submit Event</span></a>' );
}

